import Vue from 'vue'
import Vuex from 'vuex'
import auth from '@/store/modules/auth.js'
import user from '@/store/modules/user.js'
import socket from '@/store/modules/socket.js'
import info from '@/store/modules/info.js'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  modules: {
    auth,
    user,
    socket,
    info
  },
  strict: debug
})
